import http from "../http-rda";

class DataService {
  getAll(params) {
    return http.get("/enrollments-waiting-list", { params });
  }

  getByEnrollment(enrollmentId) {
    return http.get(`/enrollments/${enrollmentId}/waiting-list`);
  }

  respond(enrollmentId, accepted) {
    return http.post(`/enrollments/${enrollmentId}/waiting-list`, {
      accepted,
    });
  }

  updateStatus(enrollmentId, status) {
    return http.patch(`/enrollments/${enrollmentId}/waiting-list`, { status });
  }

  getIndicators(params) {
    return http.get("/enrollments-waiting-list/indicators", { params });
  }

  getNotificationCount() {
    return http.get("/enrollments-waiting-list/notifications");
  }

  markNotificationsRead() {
    return http.patch("/enrollments-waiting-list/notifications/read");
  }

  getEnrollmentCycles() {
    return http.get("/v2/cycles-to-enrollment");
  }

  getCycleGradeCalendars() {
    return http.get("/cycle-grades/calendars");
  }

  setCycleGradeActive(cycleGradeId, calendarId, active) {
    return http.patch(
      `/cycle-grades/${cycleGradeId}/calendars/${calendarId}`,
      { active }
    );
  }
}

export default new DataService();
